import React, { useContext, useEffect, useRef } from 'react'

import { WappContext } from 'wapplr-react/dist/common/Wapp'
import { DefaultContentComponent } from 'karrierhub-ui/dist/common/src/components/Paper'

import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'
import Menu from 'karrierhub-ui/dist/common/src/components/Menu'

import AppContext from '../../../App/context'
import Avatar from '../../../Avatar/me'

import { UserMenuBase } from '../UserMenuBase'
import { NotificationIcon } from '../NotificationIcon'

import IconButton from '../../../IconButton'

function NotificationMenu(props) {

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)

    const utils = getUtils(context)

    const {
        classNames,
        size
    } = props

    const user = utils.getRequestUser()

    if (!user?._id) {
        return null
    }

    return (
        <div className={classNames.notificationMenu}>
            <IconButton
                size={size}
                tip={appContext.menus.notificationsMenu}
                href={appContext.routes['user' + 'Route'] + '/' + user._id + appContext.routes['user' + 'NotificationsRoute']}
                variant={'text'}
            >
                <NotificationIcon classNames={classNames} />
            </IconButton>
        </div>
    )
}

const ModalContentComponent = React.forwardRef(({ storageUserMenuScrollTop, ...props }, ref) => {

    const _ref = useRef()

    function saveScrollTop() {
        if (storageUserMenuScrollTop) {
            const current = _ref.current
            storageUserMenuScrollTop({ ['userMenuScrollTop']: current?.firstChild?.scrollTop || 0 }, true)
        }
    }

    useEffect(() => {
        const onScrollListener = function() {
            saveScrollTop()
        }
        if (_ref.current?.firstChild) {
            _ref.current?.firstChild.addEventListener('scroll', onScrollListener)
        }
        return () => {
            if (_ref.current?.firstChild) {
                _ref.current?.firstChild.removeEventListener('scroll', onScrollListener)
            }
        }
    })

    return <DefaultContentComponent
        {...props}
        ref={(e) => {
            _ref.current = e
            if (ref) {
                if (typeof ref === 'function') {
                    ref(e)
                } else if (ref && typeof ref === 'object') {
                    ref.current = e
                }
            }
        }}
    />
})

export default function UserMenuDesktop(props) {

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)

    const utils = getUtils(context)

    const {
        classNames,
        size,
        storageUserMenuScrollTop,
        ...rest
    } = props

    const user = utils.getRequestUser()

    if (!user?._id) {
        return null
    }

    const modalContentRef = useRef()

    return (
        <div className={classNames.userMenuDesktopContainer}>
            <NotificationMenu size={size} classNames={classNames} />
            <Menu
                PopoverProps={{
                    AnchorComponent: Avatar,
                    AnchorComponentProps: {
                        tip: appContext.menus.dashboardMenu,
                        variant: 'contained',
                        onlyIcon: true,
                        size,
                        imagePropName: 'icon',
                        secondaryText: ''
                    },
                    onOpen: async () => {
                        if (storageUserMenuScrollTop && modalContentRef.current?.firstChild) {
                            const scrollTop = storageUserMenuScrollTop(undefined, true).userMenuScrollTop
                            if (typeof scrollTop !== 'undefined') {
                                modalContentRef.current.firstChild.scrollTop = scrollTop
                            }
                        }
                    }
                }}
                PaperProps={{
                    size: 'default',
                    ContentComponentProps: {
                        ContentComponent: ModalContentComponent,
                        ContentComponentProps: {
                            ref: modalContentRef,
                            storageUserMenuScrollTop
                        }
                    }
                }}
                menu={[
                    {
                        MenuBaseProps: rest,
                        Component: UserMenuBase,
                        classNames,
                        user,
                        size
                    }
                ]}
            />
        </div>
    )
}
